import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorks() {
  const steps = [{
    number: '1',
    title: 'Read the "Morning Mirror" chapter',
    description: 'Understand your specific inflammation triggers.'
  }, {
    number: '2',
    title: 'Use the "No-Chop" Grocery Map',
    description: 'Stock your kitchen with joint-healing foods.'
  }, {
    number: '3',
    title: 'Follow the 10-minute assembly meals',
    description: 'Flood your system with anti-inflammatory nutrients.'
  }];
  return <section className="bg-white py-6 px-4 md:px-8" data-id="element-104">
      <div className="max-w-2xl mx-auto" data-id="element-105">
        <FadeIn data-id="element-106">
          <h2 className="text-xl md:text-2xl font-bold text-forest mb-4 text-center" data-id="element-107">
            How It Works
          </h2>
        </FadeIn>

        <div className="space-y-3" data-id="element-108">
          {steps.map((step, index) => <FadeIn key={index} delay={0.1 * (index + 1)} data-id="element-109">
              <div className="flex items-start gap-3" data-id="element-110">
                <div className="flex items-center justify-center w-9 h-9 rounded-full bg-forest text-white font-bold text-sm shadow shrink-0" data-id="element-111">
                  {step.number}
                </div>
                <div className="bg-cream p-3 rounded-lg border border-gray-100 flex-1" data-id="element-112">
                  <h3 className="font-bold text-base text-forest mb-0.5" data-id="element-113">
                    {step.title}
                  </h3>
                  <p className="text-sm text-charcoal" data-id="element-114">{step.description}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}